module.exports = __webpack_public_path__ + "assets/students-group.06f6cde8.svg";